import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';

import MaterialIcon from 'site-react/core/Icon/MaterialIcon';
import theme from 'site-react/theme';

const navigationMenuButtonStyle = css`
  background: none;
  border: 0;
  height: ${theme.spacing.minimumTargetSize}px;
  padding: 0;
  width: ${theme.spacing.minimumTargetSize}px;

  @media (min-width: ${theme.breakpoints.lg}px) {
    display: none;
  }

  &:hover,
  &:focus {
    color: ${theme.colors.neutral800};
  }

  &:active {
    color: ${theme.colors.neutral700};
  }
`;

const navigationMenuIconStyle = css`
  font-size: ${theme.spacing.xl}px;
  line-height: ${theme.spacing.minimumTargetSize}px;
`;

const NavigationMenuButton = ({ onClick }) => (
  <button className={navigationMenuButtonStyle} onClick={onClick} type="button">
    <MaterialIcon className={navigationMenuIconStyle} iconType="menu" />
  </button>
);

NavigationMenuButton.defaultProps = {};

NavigationMenuButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default NavigationMenuButton;
